/*

  Post Processing module
  handlers applying 2d screen pass PPO effects
  to final render

*/

/* global performance */

import THREE from 'three';
import {SchemaType} from '../SlideshowDefinition';
import {ShaderPass} from './lib/ShaderPass';
import {VignetteShader} from './shaders/VignetteShader';
import {GrainShader} from './shaders/GrainShader';
import {TintShader} from './shaders/TintShader';

let renderFBO: THREE.WebGLRenderTarget;
let grainPass: ShaderPass<typeof GrainShader>;
let vigPass: ShaderPass<typeof VignetteShader>;
let tintPass: ShaderPass<typeof TintShader>;

export function init(renderer: THREE.WebGLRenderer, props: SchemaType): void {
  const size = renderer.getSize(new THREE.Vector2());
  const w = size.width;
  const h = size.height;

  renderFBO = new THREE.WebGLRenderTarget(w, h, {});

  vigPass = new ShaderPass(renderer, VignetteShader);
  vigPass.shader.uniforms.tDiffuse.value = renderFBO.texture;
  vigPass.shader.uniforms.amount.value = props.vignette;

  grainPass = new ShaderPass(renderer, GrainShader);
  grainPass.shader.uniforms.tDiffuse.value = vigPass.fbo.texture;
  grainPass.shader.uniforms.amount.value = props.grain;

  tintPass = new ShaderPass(renderer, TintShader);
  tintPass.shader.uniforms.tDiffuse.value = grainPass.fbo.texture;
  tintPass.shader.uniforms.amount.value = props.tintAmount;
  tintPass.shader.uniforms.color.value = new THREE.Color(props.tintColor);
}

export function render(
  renderer: THREE.WebGLRenderer,
  scene: THREE.Scene,
  camera: THREE.OrthographicCamera
): void {
  renderer.setRenderTarget(renderFBO);
  renderer.render(scene, camera);
  grainPass.shader.uniforms.time.value = performance.now() / 1000;
  vigPass.render();
  grainPass.render();
  tintPass.render(true);
}

export function resize(w: number, h: number, dpr: number): void {
  renderFBO.setSize(w * dpr, h * dpr);
  grainPass.setSize(w * dpr, h * dpr);
  vigPass.setSize(w * dpr, h * dpr);
  tintPass.setSize(w * dpr, h * dpr);
}
